module.exports = __webpack_public_path__ + "img/bul_device_pc.2d7ac56c.svg";